import { REST_URLS } from "../../common-utilities/utils/end-points/invoice-tracking";
import { HTTP_METHODS, invokeApi } from "./http-service";
import { clearOfflineData, setOfflineData } from "./offline-services";
import { INTRANETHOSTNAME } from "../../common-utilities/utils/end-points";

export const redirectToIntranetPortal = (tokenKey) => {
  clearOfflineData("user", tokenKey);
  clearOfflineData("tokens", tokenKey);
  setTimeout(() => {
    window.location.href = "/";
  }, 200);
};

export const getUserDetailsFromIntranet = (
  Authorization,
  customLogic,
  tokens,
  tokenKey,
  slug
) => {
  invokeApi(
    HTTP_METHODS.POST,
    `${INTRANETHOSTNAME}${REST_URLS.INTRANET_LOGIN}`,
    null,
    null,
    Authorization,
    slug,
    tokenKey
  )
    .then((res) => {
      if (res?.message) {
        redirectToIntranetPortal(tokenKey);
        return;
      }
      if (tokens) {
        setOfflineData("tokens", tokens, tokenKey);
      }
      const role = res?.role?.toUpperCase();
      setOfflineData("user", { ...res, role }, tokenKey);
      if (typeof customLogic === "function") {
        customLogic(res);
      }
    })
    .catch(() => {
      redirectToIntranetPortal(tokenKey);
    });
};
